function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "ICONS/TOOLS/ico-30-text");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/TOOLS/ico-30-text",
  stroke: "#000000"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(5.500000, 6.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,4 C0.333333333,2.66666667 0.333333333,1.33333333 0,0 L19,0 C18.6666667,1.33333333 18.6666667,2.66666667 19,4",
  id: "Path-6"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Path-7",
  points: "9.5 0 9.5 19 6.5 19 12.5 19"
}))));

const SvgIco30Text = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30px",
  height: "30px",
  viewBox: "0 0 30 30",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIco30Text, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ico-30-text.fc4e14f7.svg";
export { ForwardRef as ReactComponent };